// src/store/reducers/printQRReducer.js
import {
  CREATE_PRINT_QR_START,
  CREATE_PRINT_QR_SUCCESS,
  CREATE_PRINT_QR_FAILURE,
  GET_PRINT_QR_LIST_START,
  GET_PRINT_QR_LIST_SUCCESS,
  GET_PRINT_QR_LIST_FAILURE,
} from "../types/printQRTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
  printQRList: [],
  createdPrintQR: null,
  total: 0,
  currentPage: 1,
  lastPage: 1,
};

const printQRReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRINT_QR_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case CREATE_PRINT_QR_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        createdPrintQR: action.payload,
      };

    case CREATE_PRINT_QR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case GET_PRINT_QR_LIST_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PRINT_QR_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        printQRList: action.payload?.data || action.payload?.qr_codes || [],
        total: action.payload?.total || 0,
        currentPage: action.payload?.current_page || 1,
        lastPage: action.payload?.last_page || 1,
      };

    case GET_PRINT_QR_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default printQRReducer;